import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CountryCodeRes } from '../model/countryCoder';
import { Title, Meta } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

const connectNowAPI = environment.connectNowAPI;
const connectNowCompanyId = environment.connectNowCompanyId;

@Injectable({
  providedIn: 'root',
})
export class LandingPageService {
  constructor(
    private httpClient: HttpClient,
    private titleService: Title,
    private metaService: Meta
  ) {}

  // get country codes for picker
  getCountryCodesApi(): Promise<CountryCodeRes[]> {
    return new Promise((resolve, reject) => {
      this.httpClient.get(`${connectNowAPI}/public/v1/country-code`).subscribe({
        next: (res: any) => {
          resolve(res);
        },
        error: (err: HttpErrorResponse) => {
          reject(err);
        },
        complete: () => {
          // resolve(this.userID);
        },
      });
    });
  }

  // create new enquiry for request callback
  createNewEnquiryApi(req: any) {
    return new Promise((resolve, reject) => {
      this.httpClient
        .post(
          `${connectNowAPI}/public/v1/client/${connectNowCompanyId}/enquiry`,
          req
        )
        .subscribe({
          next: (res: any) => {
            resolve(res);
          },
          error: (err: HttpErrorResponse) => {
            reject(err);
          },
          complete: () => {
            // resolve(this.userID);
          },
        });
    });
  }

  getRechargePlans(): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = `${connectNowAPI}/public/v1/recharge_plan`;
      this.httpClient.get(url).subscribe({
        next: (r: any) => {
          resolve(r);
        },
        error: (err: HttpErrorResponse) => {
          reject(err);
        },
        complete: () => {
          console.log('complete');
        },
      });
    });
  }
}
